import { render, staticRenderFns } from "./CommentEditModal.vue?vue&type=template&id=4048268a&scoped=true"
import script from "./CommentEditModal.vue?vue&type=script&lang=js"
export * from "./CommentEditModal.vue?vue&type=script&lang=js"
import style0 from "./CommentEditModal.vue?vue&type=style&index=0&id=4048268a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048268a",
  null
  
)

export default component.exports